import React, { useState } from 'react'
import { useRouter } from 'next/router'

import { TransitTimeEstimateForm } from '../components/forms/TransitTimeCalculatorForm'
import { TransitTimeCalculatorResult } from '../components/transit-time-calculator/TransitTimeCalculatorResult'

const TransitTimeCalculator: React.FunctionComponent = () => {
  const [transitTimeResult, setTransitTimeResult] = useState({})
  const [loading, setLoading] = useState(false)

  const router = useRouter()

  const isTransitTimeCalculatorPage =
    router.pathname === '/transit-time-calculator'

  const formWrapperStyle = isTransitTimeCalculatorPage ? 'bg-gray-light' : ''

  const calculatorPageContainerStyle = 'py-6 md:flex-row justify-center'

  const servicePageContainerStyle =
    'pt-10 items-center min-h-[242px] lg:py-10 lg:min-h-[282px] lgMd:flex-row lg:justify-between'

  const formContainerStyle = isTransitTimeCalculatorPage
    ? calculatorPageContainerStyle
    : servicePageContainerStyle

  const transitTimeSectionStyles = isTransitTimeCalculatorPage
    ? 'mb-[100px] lg:mb-[400px]'
    : ''

  const showResult =
    isTransitTimeCalculatorPage &&
    (Object.keys(transitTimeResult).length > 0 || loading)

  return (
    <section className={transitTimeSectionStyles}>
      <div className={`${formWrapperStyle}`}>
        <div
          className={`flex flex-col max-w-screen-2xl mx-auto px-6 sm:px-10 ${formContainerStyle}`}
        >
          {!isTransitTimeCalculatorPage && (
            <div className="mb-6 w-full lgMd:max-w-[557px] xl:min-w-[520px]">
              <h1 className="mb-3 text-[34px] font-ttHovesDemiBold lgMd:min-w-max">
                Get transit times by location
              </h1>
              <p>
                Get transit times between direct origin and destination points
                by entering Origin and Destination zip/postal codes and clicking
                submit button.
              </p>
            </div>
          )}
          <TransitTimeEstimateForm
            isTransitTimeCalculatorPage={isTransitTimeCalculatorPage}
            loading={loading}
            setLoading={setLoading}
            setTransitTimeResult={setTransitTimeResult}
          />
        </div>
      </div>
      {showResult && (
        <div className="mx-auto max-w-screen-2xl">
          <TransitTimeCalculatorResult
            loading={loading}
            result={transitTimeResult}
          />
        </div>
      )}
    </section>
  )
}

export default TransitTimeCalculator
